module.exports = __webpack_public_path__ + "static/media/map1.19d5c534.png";